import { Text } from '@antimatterhq/ui/components/typography';
import { count } from '@antimatterhq/ui/utils/format';
import { Skeleton } from '@antimatterhq/ui/components/skeleton';
import { DatasourceSummary } from '@/types/api';

interface DataSourceEventCountProps {
  summaryWithAlertsAndMetrics: DatasourceSummary;
  period: 'last24hrs' | 'last7days';
  className?: string;
  'data-testid'?: string;
  isLoading: boolean;
}

export const DataSourceEventCount = ({
  summaryWithAlertsAndMetrics,
  period,
  className,
  'data-testid': testId,
  isLoading,
}: DataSourceEventCountProps) => {
  const eventCount =
    period === 'last24hrs'
      ? summaryWithAlertsAndMetrics?.metrics?.eventsLast24hours
      : summaryWithAlertsAndMetrics?.metrics?.eventsLast7days;

  if (isLoading) {
    return <Skeleton className="h-4 w-10" />;
  }

  if (eventCount === undefined) {
    return <Text className="font-medium">-</Text>;
  }

  return (
    <div className={className} data-testid={testId}>
      <Text className="font-medium">{count(eventCount)}</Text>
    </div>
  );
};
